export type modelEnum =
  | 'Ledig'
  | 'Rentner'
  | 'Verheiratete ohne Kinder'
  | 'Verh. Alleinverdiener mit zwei Kindern'
  | 'Verh. Doppelverdiener mit zwei Kindern'

export enum Model {
  SINGLE = 'single',
  RETIRED = 'retired',
  MARRIED_WITHOUT_CHILDREN = 'marriedWithoutChildren',
  MARRIED_WITH_CHILDREN = 'marriedWithChildren',
  MARRIED_WITH_CHILDREN_AND_DUAL_INCOME = 'marriedWithChildrenAndDualIncome'
}
